import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageCarouselProps {
  images: string[];
  autoPlayInterval?: number;
}
export function ImageCarousel({
  images,
  autoPlayInterval = 4000
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, autoPlayInterval);
    return () => clearInterval(interval);
  }, [images.length, autoPlayInterval]);
  const goToPrevious = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  const goToNext = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <div className="relative group" data-id="element-105">
      {/* Main Image */}
      <div className="relative overflow-hidden rounded-xl" data-id="element-106">
        <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} className="w-full h-auto transition-opacity duration-500" data-id="element-107" />
      </div>

      {/* Navigation Arrows - Always visible on mobile, hover on desktop */}
      <button onClick={goToPrevious} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-2 shadow-lg opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200" aria-label="Previous image" data-id="element-108">
        <ChevronLeft className="w-5 h-5" data-id="element-109" />
      </button>
      <button onClick={goToNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-2 shadow-lg opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200" aria-label="Next image" data-id="element-110">
        <ChevronRight className="w-5 h-5" data-id="element-111" />
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-112">
        {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-113" />)}
      </div>
    </div>;
}